export default {
  state: {
    selectedComponent: 'UploadQuestions', // UploadQuestions //uploadQuestionsDone
    currentSection: '',

    // Upload Questionnaire Drawer states
    isSelfServiceDrawerOpen: false,
    isSendToAdminDrawerOpen: false,
    uploadMode: null, // 'selfService' | 'sendToAdmin'
    selectedProductForUpload: null, // Selected product object for questionnaire upload

    sectionsDocs: [
      {
        title: 'Section name (5/8)',
        docQuestions: [
          {
            matchScore: 'Best match',
            question:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          },
          {
            matchScore: 'Best match',
            question:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          },
        ],
      },
      {
        title: 'Section name (5/6)',
        docQuestions: [
          {
            question:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          },
          {
            question:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          },
          {
            question:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          },
          {
            question:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          },
          {
            question:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          },
          {
            question:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          },
          {
            question:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          },
        ],
      },
      {
        title: 'Section name (6/10)',
        docQuestions: [
          {
            matchScore: 'Best match',
            question:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          },
          {
            matchScore: 'Best match',
            question:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          },
          {
            matchScore: 'Best match',
            question:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          },
          {
            matchScore: 'Best match',
            question:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          },
          {
            matchScore: 'Best match',
            question:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          },
          {
            matchScore: 'Best match',
            question:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          },
          {
            matchScore: 'Best match',
            question:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          },
        ],
      },
    ],
  },
  mutations: {
    SET_SELECTED_COMPONENT(state, value) {
      state.selectedComponent = value
    },
    SET_SELECTED_PRODUCT_FOR_UPLOAD(state, value) {
      console.log('SET_SELECTED_PRODUCT_FOR_UPLOAD - value:', value)
      state.selectedProductForUpload = value
    },
    SET_CURRENT_SECTION(state, value) {
      state.currentSection = value
    },
    SET_SELF_SERVICE_DRAWER_OPEN(state, value) {
      state.isSelfServiceDrawerOpen = value
      if (value) {
        state.uploadMode = 'selfService'
      }
    },
    SET_SEND_TO_ADMIN_DRAWER_OPEN(state, value) {
      state.isSendToAdminDrawerOpen = value
      if (value) {
        state.uploadMode = 'sendToAdmin'
      }
    },
    RESET_UPLOAD_MODE(state) {
      state.uploadMode = null
      state.isSelfServiceDrawerOpen = false
      state.isSendToAdminDrawerOpen = false
    },
    CLEAR_UPLOAD_MODE(state) {
      // Clear upload mode without closing the drawer
      state.uploadMode = null
    },
  },
  getters: {
    GET_SELECTED_COMPONENT(state) {
      return state.selectedComponent
    },
    GET_SECTIONS_DOC(state) {
      return state.sectionsDocs
    },
    GET_CURRENT_SECTION(state, value) {
      return state.currentSection
    },
    GET_SELF_SERVICE_DRAWER_OPEN(state) {
      return state.isSelfServiceDrawerOpen
    },
    GET_SEND_TO_ADMIN_DRAWER_OPEN(state) {
      return state.isSendToAdminDrawerOpen
    },
    GET_UPLOAD_MODE(state) {
      return state.uploadMode
    },
    GET_SELECTED_PRODUCT_FOR_UPLOAD(state) {
      return state.selectedProductForUpload
    },
  },
}
